import React, { Component } from "react";
import Input from "../Input/Input";
import Button from "../Button/Button";
import { withFirebase } from "../Firebase/Firebase";
import { validEmail } from "../../config";

import "./SignIn.css";

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    message: ""
  };

  handleInputEvent = (e, key) => {
    this.setState({
      [key]: e.target.value
    });
  };

  handleLogIn = async e => {
    e.preventDefault();
    try {
      await this.props.methods.signIn(this.state.email, this.state.password);
    } catch (err) {
      this.setState({
        message: err.message
      });
    }
  };

  render() {
    const { email, password } = this.state;
    return (
      <div className="SignIn">
        <Input
		  title="Email"
		  type="email"
		  value={email}
		  validate={email => validEmail.test(String(email).toLowerCase())}
          onChange={e => this.handleInputEvent(e, "email")}
        />
        <Input
          title="Password"
          type="password"
          value={password}
          onChange={e => this.handleInputEvent(e, "password")}
        />
        <Button onClick={this.handleLogIn}>Log in</Button>
        <div>{this.state.message}</div>
      </div>
    );
  }
}

export default withFirebase(SignIn);



// WEBPACK FOOTER //
// ./src/components/SignIn/SignIn.js